module.exports = __webpack_public_path__ + "img/cp73-r2.0b76276f.jpg";